module.exports = "/images/flag-fr.svg?58b0f5306a65b9a41468a8072fd1e6ea";